//
// Employer profile pages: coverage pills (one open at a time, Escape/click-outside close)
// and region expanders. Panels are server-rendered and toggled with the `hidden` attribute;
// nothing here injects markup. Spec 05 § Scripts.
//
const profile = document.querySelector('.ep-profile');

if (profile) {
	const pills = Array.from(profile.querySelectorAll('.ep-pill[data-pill]'));

	// The server renders no state on the pills (without JS every panel is shown); from here on they are toggles.
	pills.forEach((pill) => pill.setAttribute('aria-expanded', 'false'));

	const panelFor = (pill) => {
		const id = pill.getAttribute('aria-controls');
		return id ? document.getElementById(id) : null;
	};

	const closePill = (pill) => {
		pill.setAttribute('aria-expanded', 'false');
		const panel = panelFor(pill);
		if (panel) {
			panel.hidden = true;
		}
	};

	const closeAllPills = (except) => {
		pills.forEach((pill) => {
			if (pill !== except) {
				closePill(pill);
			}
		});
	};

	pills.forEach((pill) => {
		pill.addEventListener('click', () => {
			const isOpen = pill.getAttribute('aria-expanded') === 'true';
			closeAllPills(pill);
			if (isOpen) {
				closePill(pill);
				return;
			}
			pill.setAttribute('aria-expanded', 'true');
			const panel = panelFor(pill);
			if (panel) {
				panel.hidden = false;
			}
		});
	});

	document.addEventListener('click', (event) => {
		if (!(event.target instanceof Element) || event.target.closest('.ep-pill-wrap, .ep-pill-panel')) {
			return;
		}
		closeAllPills(null);
	});

	document.addEventListener('keydown', (event) => {
		if (event.key !== 'Escape') {
			return;
		}
		const open = pills.find((pill) => pill.getAttribute('aria-expanded') === 'true');
		if (open) {
			closePill(open);
			open.focus();
		}
	});

	profile.querySelectorAll('.ep-region__toggle[data-expander]').forEach((toggle) => {
		toggle.addEventListener('click', () => {
			const panel = document.getElementById(toggle.getAttribute('aria-controls') || '');
			if (!panel) {
				return;
			}
			const expand = toggle.getAttribute('aria-expanded') !== 'true';
			toggle.setAttribute('aria-expanded', expand ? 'true' : 'false');
			panel.hidden = !expand;
			const label = expand ? toggle.dataset.labelHide : toggle.dataset.labelShow;
			const text = toggle.querySelector('.ep-region__toggle-label') || toggle;
			if (label) {
				text.textContent = label;
			}
		});
	});
}
